import {
    GET_ENTITY,
    EDIT_ENTITY,
    ADD_ENTITY,
    ALL_ENTITY
  } from "./actionTypes"

  export const allEntity = entity => {
    return {
      type: ALL_ENTITY,
      payload: entity,
    }
  }

  export const getEntity = (entity) => {
    return {
      type: GET_ENTITY,
      payload: {entity},
    }
  }

  export const editEntity =  (entity,history) => {
    return {
      type: EDIT_ENTITY,
      payload: { entity,history},
    }
  }

  export const addEntity =  (entity,history) => {
    return {
      type: ADD_ENTITY,
      payload: { entity,history},
    }
  }